import React from "react";
import { Box, Typography, Grid } from "@mui/material";

// Child Component: RSA (reusable service cards grid)
const RSA = ({ heading, cards }) => {
  // Helper: break array into rows of four elements each
  function chunkArray(arr, size) {
    const result = [];
    for (let i = 0; i < arr.length; i += size) {
      result.push(arr.slice(i, i + size));
    }
    return result;
  }

  const ROWS = chunkArray(cards, 4);

  const getCardBoxSx = () => ({
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
    borderRadius: "12px",
    background: "#fff",
    boxShadow: "0 2px 12px 0 rgba(210,220,216,0.045)",
    padding: "20px 8px 12px 8px",
    margin: 0,
    height: "100%",
    width: "100%",
  });

  return (
    <>
      <style>{`
        .rsa-title {
          color: #222d4c;
          font-weight: 500;
          font-size: 1rem;
          text-align: center;
          font-family: 'Poppins',sans-serif;
          margin-top: 6px;
          word-break: break-word;
          line-height: 1.2;
        }
        .rsa-icon {
          width: 64px;
          height: 64px;
          object-fit: contain;
          background: #fff;
          border-radius: 50%;
          border: 3px solid #eaf5e6;
          box-shadow: 0 2px 8px 0 rgba(115,200,121,0.05);
        }
        @media (max-width: 900px) {
          .rsa-grid-item { min-width: 120px;}
        }
        @media (max-width: 520px) {
          .rsa-title { font-size: 0.97rem;}
          .rsa-icon { width: 54px; height: 54px; }
        }
      `}</style>
      <Box
        className="rsa-slider-container max-w-screen-xl mb-8 pb-8"
        sx={{
          maxWidth: "1020px",
          margin: "0 auto",
          pt: 1,
          width: "100%",
        }}
      >
        <h2 className="rsa-headingg main-heading-font-size text-center">
          {heading}
        </h2>
        {ROWS.map((row, rowIdx) => (
          <Grid
            container
            spacing={{ xs: 2, sm: 3, md: 4 }} // even gap between cards
            justifyContent="center"
            alignItems="stretch"
            key={`rsa-row-${rowIdx}`}
            sx={{
              mb: rowIdx !== ROWS.length - 1 ? { xs: 1, sm: 2 } : 0,
              maxWidth: "100%",
            }}
          >
            {row.map((card, colIdx) => (
              <Grid
                item
                xs={12}
                sm={6}
                md={3}
                key={`card-${rowIdx * 4 + colIdx}`}
                className="rsa-grid-item"
                sx={{
                  display: "flex",
                  flex: 1,
                  minWidth: 0,
                  maxWidth: "100%",
                }}
              >
                <Box sx={getCardBoxSx()}>
                  <img src={card.icon} className="rsa-icon" alt={card.title} />
                  <span className="rsa-title">{card.title}</span>
                </Box>
              </Grid>
            ))}
          </Grid>
        ))}
      </Box>
    </>
  );
};

export default RSA;
